import { Typography } from '@/components/ui/typography'
import { cn } from '@/lib/utils'

export type AdminUserStatusKind = 'active' | 'inactive' | 'invited'

export function AdminUserStatus({
  kind,
  label,
  detail,
}: {
  kind: AdminUserStatusKind
  label: string
  detail?: string
}) {
  return (
    <div className="min-w-0">
      <div className="flex items-center gap-2">
        <span
          className={cn(
            'size-2 shrink-0 rounded-full',
            kind === 'active' && 'bg-emerald-500',
            kind === 'inactive' && 'bg-primary/30',
            kind === 'invited' && 'bg-amber-500'
          )}
          aria-hidden="true"
        />
        <Typography as="span" variant="body-sm" className="text-primary">
          {label}
        </Typography>
      </div>
      {detail ? (
        <Typography
          variant="body-sm"
          className="mt-0.5 text-[11px] text-primary/70"
        >
          {detail}
        </Typography>
      ) : null}
    </div>
  )
}
